/* eslint-disable import/no-unresolved */
import { memo, useLayoutEffect, useState, useEffect } from "react";
import { FormikProps } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  findKeysByValue,
  loanPageHelperText
} from "../../../../../helpers/FormDetails/ProposalDetails/resources";
import CustomSelect from "../../../../../shared/CustomSelect";
import CustomTextField from "../../../../../shared/CustomTextField";
import CustomHelperText from "../../../../../shared/CustomHelperText";
import { LoanDetails } from "../../../../../helpers/FormDetails/ProposalDetails/interfaces";

interface Props {
  formik: FormikProps<LoanDetails>;
}
function PlanDetails({
  formik: { errors, handleBlur, setFieldTouched, touched, values, handleChange, setFieldValue }
}: Props) {
  const coverOption = useAppSelector((state) => state.masterdata_reducer?.coverType) || {};
  // const coverTerm = useAppSelector((state) => state.masterdata_reducer?.policyTerm);
  const premiumPaymentTerm =
    useAppSelector((state) => state.masterdata_reducer?.premiumPaymentTerm) || {};
  const {
    planDetails: {
      coverOption: coverOptionField,
      deathSumAssured,
      coverTerm,
      premiumPaymentTerm: premiumPaymentTermField
    } = {} as any
  } = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};
  const [coverTermOptions, setCoverTermOptions] = useState<string[]>();
  useLayoutEffect(() => {
    const options = Array.from({ length: +(values.loan?.loanTerm || 30) }, (_, index) =>
      (index + 1).toString()
    );
    setCoverTermOptions(options);
    if (values.plan?.coverTerm > values.loan?.loanTerm) setFieldValue("plan.coverTerm", options[0]);
  }, [values?.loan?.loanTerm]);
  const isProportionateLead = useAppSelector((state) => state.common?.isProportionateLead);
  useEffect(() => {
    setFieldValue(
      "plan.coverOptionCode",
      findKeysByValue(coverOption, values.plan?.coverOption) || ""
    );
  }, [values.plan?.coverOption]);

  useEffect(() => {
    setFieldValue("plan.coverTerm", values.loan?.loanTerm);
  }, [values?.loan?.loanTerm]);

  useEffect(() => {
    setFieldValue(
      "plan.premiumPaymentTermCode",
      findKeysByValue(premiumPaymentTerm, values.plan?.premiumPaymentTerm) || ""
    );
  }, [values.plan?.premiumPaymentTerm]);
  return (
    <div>
      <span className="font-montserrat text-black text-base font-bold mt-8 mb-6 flex">
        Plan Details
      </span>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
        {coverOptionField?.visible && (
          <CustomSelect
            requiredStar={coverOptionField?.required}
            disabledField={coverOptionField.disabled}
            label={coverOptionField?.label}
            options={Object.values(coverOption)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="plan.coverOption"
            value={values.plan.coverOption}
            error={errors.plan?.coverOption}
            touched={touched.plan?.coverOption}
          />
        )}
        {deathSumAssured?.visible && (
          <div>
            <CustomTextField
              requiredStar={deathSumAssured?.required}
              disabledField={deathSumAssured?.disabled}
              label={deathSumAssured?.label}
              className="flex-1"
              onChange={() => {}}
              handleBlur={handleBlur}
              value={
                (values.plan?.deathSumInsured &&
                  Number(values.plan?.deathSumInsured).toLocaleString("en-IN")) ||
                ""
              }
              name="plan.deathSumInsured"
              error={errors.plan?.deathSumInsured}
              touched={touched.plan?.deathSumInsured}
            />
            <CustomHelperText>{loanPageHelperText.deathSumAssured}</CustomHelperText>
          </div>
        )}
        {coverTerm?.visible && (
          <CustomSelect
            requiredStar={coverTerm?.required}
            label={coverTerm?.label}
            disabledField={coverTerm?.disabled}
            options={coverTermOptions!}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="plan.coverTerm"
            value={values.plan.coverTerm}
            error={errors.plan?.coverTerm}
            touched={touched.plan?.coverTerm}
          />
        )}
        {premiumPaymentTermField?.visible && (
          <CustomSelect
            requiredStar={premiumPaymentTermField?.required}
            disabledField={premiumPaymentTermField?.disabled || isProportionateLead}
            label={premiumPaymentTermField?.label}
            options={Object.values(premiumPaymentTerm)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="plan.premiumPaymentTerm"
            value={values.plan.premiumPaymentTerm}
            error={errors.plan?.premiumPaymentTerm}
            touched={touched.plan?.premiumPaymentTerm}
          />
        )}
      </div>
    </div>
  );
}

export default memo(PlanDetails);
